import ufeApi from 'services/api/ufeApi';

function getEvents(token, {
    language, country, preferredStoreId, preferredZipCode, filters, eventsOnly = false
}) {
    const languageLowerCase = language.toLowerCase();
    const sdnDomain = Sephora.configurationSettings.sdnApiHost;
    const url = `${sdnDomain}/v1/store-experience/service/event/events?storeId=${preferredStoreId}&zipCode=${preferredZipCode}&channel=web&locale=${languageLowerCase}-${country}&country=${country}&eventsOnly=${eventsOnly}${
        filters ? `&${filters}` : ''
    }`;

    return ufeApi
        .makeRequest(url, {
            method: 'GET',
            headers: { 'x-requested-source': 'rwd', authorization: `Bearer ${token}` }
        })
        .then(data => data);
}

export default { getEvents };
